import { LABEL_CLASS } from '../candidatoFormExternoEtapa2Page.definitions';

interface CampoSimNaoProps {
  label: string;
  valor: boolean;
  onChange: (valor: boolean) => void;
}

export default function CampoSimNao({ label, valor, onChange }: CampoSimNaoProps) {
  return (
    <div>
      <label className={LABEL_CLASS}>{label}</label>
      <div className="flex gap-3">
        {[
          { texto: 'Sim', valor: true },
          { texto: 'Não', valor: false },
        ].map((opcao) => (
          <button
            key={opcao.texto}
            type="button"
            onClick={() => onChange(opcao.valor)}
            className={`flex-1 rounded-xl border-2 p-3 font-medium transition-colors ${
              valor === opcao.valor
                ? 'border-indigo-600 bg-indigo-50/50 text-indigo-700'
                : 'border-gray-100 text-gray-600 hover:border-indigo-200'
            }`}
          >
            {opcao.texto}
          </button>
        ))}
      </div>
    </div>
  );
}
